// Transparent-background logo, generated from user's original jpeg
export const LOGO_URL = "/assets/logo-pedrocchi.png";

export const EXTERIOR_SKETCH =
  "https://customer-assets.emergentagent.com/job_dining-memories/artifacts/7hl2i87i_ChatGPT%20Image%2021%20mag%202026%2C%2011_17_55.png";

// Note: user-uploaded IMG_8709.jpeg is actually a HEIC file mislabeled as .jpeg
// and cannot be decoded by browsers. Using a similar moody trattoria interior.
export const INTERIOR_MOOD =
  "https://images.pexels.com/photos/941861/pexels-photo-941861.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200";

export const CARNIVAL =
  "https://customer-assets.emergentagent.com/job_dining-memories/artifacts/t7zar6th_ChatGPT%20Image%2021%20mag%202026%2C%2011_17_55.png";

export const PASTA =
  "https://images.pexels.com/photos/546945/pexels-photo-546945.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const WINE_CELLAR =
  "https://images.pexels.com/photos/5690802/pexels-photo-5690802.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const VENICE_CANAL =
  "https://images.pexels.com/photos/36393803/pexels-photo-36393803.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

// Home page "Specialità della casa" photos (real dishes from the restaurant)
export const SPRITZ =
  "https://customer-assets.emergentagent.com/job_dining-memories/artifacts/2ic35xna_ChatGPT%20Image%2022%20mag%202026%2C%2018_48_06.png";
export const PIZZA_MARGHERITA =
  "https://customer-assets.emergentagent.com/job_dining-memories/artifacts/av6iwofp_ChatGPT%20Image%2022%20mag%202026%2C%2018_49_13.png";
export const BURGER =
  "https://customer-assets.emergentagent.com/job_dining-memories/artifacts/erhxmuof_ChatGPT%20Image%2022%20mag%202026%2C%2018_51_10.png";
export const CAPRESE =
  "https://customer-assets.emergentagent.com/job_dining-memories/artifacts/2yv13sgf_Screenshot%202026-05-22%20alle%2018.37.39.png";

// Restaurant static info
export const RESTAURANT = {
  name: "Ristorante Pedrocchi",
  tagline: "Cucina veneziana ed internazionale dal 1971",
  address: "Campo San Geremia · Cannaregio 278A · 30121 Venezia (VE)",
  phone: "+39 041 723037",
  email: "pedrocchi.venezia@gmail.com",
  hours: [
    { day: "Lunedì", time: "09:30 – 23:00" },
    { day: "Martedì", time: "09:30 – 23:00" },
    { day: "Mercoledì", time: "Riposo settimanale" },
    { day: "Giovedì", time: "09:30 – 23:00" },
    { day: "Venerdì", time: "09:30 – 23:00" },
    { day: "Sabato", time: "09:30 – 23:00" },
    { day: "Domenica", time: "09:30 – 23:00" },
  ],
};
